import { __awaiter } from "tslib";
import axios from 'axios';
import { baseSite } from '../baseSite';
const MSRC_ENV_HTTP_HEADER_NAME = 'x-app-env';
/** The actual headers we're going to return
 *
 * @type {_.Dictionary<string>?}
 */
let resultHeaderData;
/** Central store for promise to fetch this stuff */
let awaiter = null;
/** Simple promise which makes the call to actually get the headers
 * > Note: makes an http request
 *
 * @private
 * @returns {Promise<_.Dictionary<string>?>} all the headers on the app
 */
const getHttpHeadersFromRemote = () => axios.head(baseSite).then(response => {
    resultHeaderData = response.headers;
    return resultHeaderData;
});
/** Gets any custom headers we have configured and returns via a promise.
 *
 * @returns {Promise<_.Dictionary<string>>} returns a promise that awaits the http header dictionary.
 */
export const getHttpHeaders = () => {
    if (!awaiter) {
        awaiter = getHttpHeadersFromRemote();
    }
    return awaiter;
};
/** Gets specifically just the current env (ppe, prod, or dev), to be consumed
 * by external code.
 */
export const getEnvironment = () => __awaiter(void 0, void 0, void 0, function* () {
    return getHttpHeaders()
        .then(headerList => headerList[MSRC_ENV_HTTP_HEADER_NAME])
        .catch(w => console.log(w));
});
